export interface SimpleUser {
  email: string;
  fullName: string;
  username: string;
  rsvp: string;
  blocked: boolean;
  avatarUrl: string;
  jobTitle: string;
}

export interface SimpleCompany {
  id: string;
  name: string;
  description: string;
  companyType: 'ADVERTISER' | 'PRODUCER';
}

export interface User {
  username?: string;
  firstName?: string;
  lastName?: string;
  company?: SimpleCompany;
  companyId?: string;
  email?: string;
  message?: string | null;
  avatarUrl?: string | null;
  verified?: boolean;
  blocked?: boolean | null;
  blockDate?: number | null;
  unblockDate?: number | null;
  activationDate?: number;
  activationStatus?: string;
  userConnectionId?: string | null;
  termsAndConditionsAgree?: boolean;
  deleted?: boolean;
  inviter?: string;
  jobTitle?: string;
  termsAndConditionsAcceptedDate?: number | null;
  lastSeen?: number | null;
  lastauthattempt?: number | null;
  lastauthsuccess?: number | null;
  oneshotaccess?: boolean;
  subscriptionaccess?: boolean;
  brandId?: string | null;
  code?: string;
  fullName?: string;
  storagePath?: string;
  domainEmail?: string;
  userPermissionType?: string;
  userType?: string;
}
export interface FormData {
  username: string;
}

export interface UserFormWrapper {
  formData: FormData;
  userData: User;
}

export enum OwnershipTransferTypes {
  PROJECT = 'PROJECT',
  WORKSPACE = 'WORKSPACE',
}

export interface ProfileSettings {
  username: string;
  language: string;
  startWeekOn: string;
  dateFormat: string;
  timeFormat: string;
  timeDisplay: string;
  timeZone: string;
  currency: string;
  logTime: number;
  numberFormat: string;
  soundChatNotifications: boolean;
  generalNotifications: boolean;
  muteConversations: boolean;
  twoFa: boolean;
  mfaMechanism: string;
  defaultBrandId?: string;
  dateTimePattern: string;
  startWeekDayIndex: number;
  timePattern: string;
  datePattern: string;
}

export interface PasswordComplexityParams {
  minLength: number;
  mixedCaseRequired: boolean;
  numberRequired: boolean;
  specialCharacterRequired: boolean;
}

export interface SimpleUserWithActivationStatus extends SimpleUser {
  userActivationStatus: string;
}

export interface StatusInfo {
  code: string;
  label: string;
}

export interface UserToken {
  token: string;
}

export interface UserSearchResult {
  data: User[];
  hasNext: boolean;
  pagingState: string;
}

export interface UserQRAuthenticator {
  uri: string;
  factorId: string;
  secret: string;
}
